<app-CutomerKarshnasForm
[inner_Customer]="inner_Customer"
(outter_KarshnasMasol)="set_KarshnasMasol($event)">

</app-CutomerKarshnasForm>

<button *ngIf="!Proccesing_OnSubmitForm_Csutomer" type="button"
  (click)="OnSubmitFormCustomer()"  class="btn btn-danger"
  style="margin-right: 5px;"><i class="fa  fa-edit"></i> Confirm and Finalize Customer Information </button>
<button *ngIf="Proccesing_OnSubmitForm_Csutomer" type="button" class="btn btn-info"
  style="margin-right: 5px;"> Please wait... <i class="fa fa-spin fa-spinner"></i> </button>
